const KEY = `03f3d2a81853c3de021056c5d3e902a276a804717edb1b916f23ef33f8ad6bdd839d8cb0f72f6e4f72b45faa0f1353ea2dded2e2bfa0f74c66e2d90e1dc340c8b4eefbb6a53f9e5d034356efd9f7a49f8869c23eafb50ba74e51990d6cda6f6bee7a8595b00ea16f49a6c44745a482336b8d08584544bf4a43cf40cff1eebb40`;

export {KEY}